import { defineComponent as _defineComponent } from 'vue'
import { type TablePanels } from '@store';

import { useTableItem } from './table-item';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    CardTableGroupView: ComponentWithProps<Props>;
  }
}

/** `CardTableGroupView` component properties. */
export interface Props {
  tableKey: TablePanels.ModuleKey;
  loaderOptions?: Nullable<GenericObject>;
  collapsable?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardTableGroupView',
  props: {
    tableKey: null,
    loaderOptions: null,
    collapsable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  tableKey: TablePanels.ModuleKey;
  loaderOptions?: Nullable<GenericObject>;
  collapsable?: boolean;
};



const { tablePanel, tableComponent, visible } = useTableItem(props);

return { __sfc: true,props, tablePanel, tableComponent, visible }
}

})